module.exports = __webpack_public_path__ + "img/card-3.092c4afb.svg";